.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--sp-2);
  padding: 7px 13px;
  border: 1px solid var(--line2);
  border-radius: var(--radius-md);
  background: var(--surf2);
  color: var(--text);
  font-size: 11.5px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: var(--transition);
}
.btn:hover:not(:disabled) {
  border-color: var(--maroon);
  background: var(--surf3);
}
.btn:disabled {
  opacity: 0.42;
  cursor: not-allowed;
}

.sm {
  padding: 4px 9px;
  font-size: 10.5px;
}
.block {
  width: 100%;
}

.primary {
  border-color: var(--maroon);
  background: var(--maroon);
  color: #fff;
}
.primary:hover:not(:disabled) {
  background: var(--magenta);
  border-color: var(--magenta);
}

.ai {
  border-color: var(--magenta);
  background: linear-gradient(135deg, var(--maroon), var(--magenta));
  color: #fff;
}
.ai:hover:not(:disabled) {
  filter: brightness(1.12);
}

.success {
  border-color: var(--lime);
  background: transparent;
  color: var(--text-success);
}
.success:hover:not(:disabled) {
  background: color-mix(in srgb, var(--lime) 14%, transparent);
  border-color: var(--lime);
}

.danger {
  border-color: var(--magenta);
  background: transparent;
  color: var(--magenta);
}
.danger:hover:not(:disabled) {
  background: var(--magenta);
  color: #fff;
}

.warn {
  border-color: var(--amber);
  background: transparent;
  color: var(--text-warn);
}
.warn:hover:not(:disabled) {
  background: color-mix(in srgb, var(--amber) 14%, transparent);
  border-color: var(--amber);
}

.info {
  border-color: var(--aqua);
  background: transparent;
  color: var(--text-info);
}
.info:hover:not(:disabled) {
  background: color-mix(in srgb, var(--aqua) 14%, transparent);
  border-color: var(--aqua);
}

.ghost {
  border-color: transparent;
  background: transparent;
  color: var(--text2);
}
.ghost:hover:not(:disabled) {
  border-color: var(--line2);
  background: var(--surf2);
  color: var(--text);
}
